export enum paths {
	INDEX = '/',
}
